export default __webpack_public_path__ + "static/media/p1050300.44e36f66-min.c898cfd6.jpg";